import { Reducers } from '@app/reducers';
import { createSelector } from '@ngrx/store';

export const mainFeature = (state: Reducers) => state.main;

/** Select Minimized Dialogs */
export const selectMinimizedDialogs = createSelector(
  mainFeature,
  (state) => state.minimizedDialogs
);

/** Sip State */
export const selectSipState = createSelector(
  mainFeature,
  (state) => state.sipState
);

export const selectCallState = createSelector(
  mainFeature,
  (state) => state.callState
);

/** Select Calls List */
export const selectCallsList = createSelector(
  mainFeature,
  (state) => state.callsList
);

/** Select Calls Pagination */
export const selectCallsListPagination = createSelector(
  mainFeature,
  (state) => state.callsListPagination
);

/** Select Calls Loading */
export const selectCallsListLoading = createSelector(
  mainFeature,
  (state) => state.callsListLoading
);

/** Select Notifications List */
export const selectNotificationsList = createSelector(
  mainFeature,
  (state) => state.notificationsList
);

/** Select Notifications Pagination */
export const selectNotificationsPagination = createSelector(
  mainFeature,
  (state) => state.notificationsListPagination
);

/** Select Notifications Loading */
export const selectNotificationsListLoading = createSelector(
  mainFeature,
  (state) => state.notificationsListLoading
);
